import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

import { FormBuilder, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, IAutocomplete, IFieldType, IFormSchema } from "shared/types";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";
import { requestResetPassword } from "Auth/state";
import { AUTH_ACTIONS } from "Auth/types";
import { useStateActionMeta } from "Auth/utils";

const { authFormFields: fields, errors, passwordReset } = copy;

interface PasswordResetRequestProps {
  handleClose: () => void;
}

export const PasswordResetRequest: React.FC<PasswordResetRequestProps> = ({ handleClose }) => {
  const dispatch = useDispatch();
  const meta = useStateActionMeta(AUTH_ACTIONS.requestResetPassword);

  const schema: IFormSchema = useMemo(
    () => ({
      fields: [
        {
          name: "email",
          label: fields.email,
          type: IFieldType.email,
          autocomplete: IAutocomplete.email,
          validation: {
            required: errors.required,
          },
        },
      ],
      buttons: {
        primary: {
          children: passwordReset.request.button,
        },
        secondary: {
          onClick: handleClose,
        },
      },
    }),
    [handleClose]
  );

  const onSubmit = ({ email }: { email: string }) => {
    dispatch(requestResetPassword(email));
  };

  useEffect(() => {
    if (meta?.status === IAPIState.succeeded) {
      handleClose();
    }
  }, [handleClose, meta]);

  return (
    <Modal icon={User} title={passwordReset.request.title} handleClose={handleClose}>
      <Spacer size="l">
        <span>{passwordReset.request.body}</span>
        <FormBuilder
          {...schema}
          onSubmit={onSubmit}
          isSubmitting={meta?.status === IAPIState.pending}
          apiErrorMessage={meta?.error ? (meta?.message ? meta.message.body : true) : false}
          apiError={meta?.error}
        />
      </Spacer>
    </Modal>
  );
};
